<template>
  <div
    v-if="date && !dateInPast"
    class="countdown-widget-component"
  >
    <p class="countdown">
      {{ config.name }}: <span class="underline">{{ formattedDate }}</span>  • <span class="underline">{{ daysUntilDate }} {{ daysUntilDate > 1 ? 'days' : 'day' }}</span>
    </p>
  </div>
</template>

<script>
import { format, differenceInCalendarDays } from 'date-fns';
import { parseApiDateString } from '@/utils';

export default {
  name: 'CountdownWidget',
  props: {
    config: {
      type: Object,
    },
  },
  computed: {
    daysUntilDate() {
      if (this.date) {
        return differenceInCalendarDays(this.date, new Date());
      }
    },
    date() {
      let date;

      if (this.userProfile) {
        if (this.userProfileConfig) {
          date = this.userProfile[this.userProfileConfig.userProfileColumnName];
        } else if (this.userProfileColumnName) {
          date = this.userProfile[this.userProfileColumnName];
        }
      }

      if (date) {
        return parseApiDateString(date).date;
      }
    },
    dateInPast() {
      return new Date() > this.date;
    },
    formattedDate() {
      if (this.date) {
        return format(this.date, 'MM/dd/yyyy');
      }
    },
    user() {
      return this.$store.getters['user/get'];
    },
    userProfile() {
      return this.user?.userProfile;
    },
    userProfileColumnName() {
      return this.config?.config?.userProfileColumnName;
    },
    userProfileConfig() {
      const id = this.config?.config?.userProfileConfigId;
      if (id) {
        const configs = this.$store.getters['userProfileConfigs/all'];
        if (configs) {
          return configs.find(config => config.id === id);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown-widget-component {
  margin: rem-calc(16);
  width: 100%;

  .countdown {
    font-size: rem-calc(18);
    text-align: center;
    margin: 0;
    font-weight: $semi-bold;

    .underline {
      text-decoration: underline;
    }
  }
}
</style>
